export { PromoBanner } from './PromoBanner';
